import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      meta: {
        title: "登录"
      },
      component: () => import('../view/login/login'),
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: "总览"
      },
      component: () => import('../view/home/index'),
    },{
      path: '/workbench',
      name: 'workbench',
      meta: {
        title: "主界面"
      },
      component: () => import('../view/workbench/workbench'),
    },
		{
      path: '/engine',
      name: 'engine',
      meta: {
        title: "基本信息"
      },
      component: () => import('../view/basic/engine'),
    },{
      path: '/capacity',
      name: 'capacity',
      meta: {
        title: "库容曲线"
      },
      component: () => import('../view/basic/capacity'),
    },{
      path: '/waterRain',
      name: 'waterRain',
      meta: {
        title: "水雨情监测"
      },
      component: () => import('../view/monitoring/waterRain'),
    },{
      path: '/displacement',
      name: 'displacement',
      meta: {
        title: "渗流监测"
      },
      component: () => import('../view/monitoring/displacement'),
    },{
      path: '/waterQuality',
      name: 'waterQuality',
      meta: {
        title: "水质监测"
      },
      component: () => import('../view/monitoring/waterQuality'),
    },{
      path: '/environment',
      name: 'environment',
      meta: {
        title: "生态环境监测"
      },
      component: () => import('../view/monitoring/environment'),
    },{
      path: '/flow',
      name: 'flow',
      meta: {
        title: "流量监测"
      },
      component: () => import('../view/monitoring/flow'),
    },{
      path: '/osmotic-pressure',
      name: 'osmotic-pressure',
      meta: {
        title: "渗压监测"
      },
      component: () => import('../view/monitoring/osmotic-pressure'),
    },{
      path: '/seepage-line-single',
      name: 'seepage-line-single',
      meta: {
        title: "浸润线示意图"
      },
      component: () => import('../view/monitoring/seepage-line-single'),
    },{
      path: '/vision',
      name: 'vision',
      meta: {
        title: "视频监控"
      },
      component: () => import('../view/monitor/vision'),
    },{
      path: '/picture',
      name: 'picture',
      meta: {
        title: "图像监控"
      },
      component: () => import('../view/monitor/picture'),
    },{
      path: '/history',
      name: 'history',
      meta: {
        title: "水雨情数据查询"
      },
      component: () => import('../view/data/history'),
    },{
      path: '/water_data',
      name: 'water_data',
      meta: {
        title: "水情数据查询"
      },
      component: () => import('../view/data/water_data'),
    },{
      path: '/rain_data',
      name: 'rain_data',
      meta: {
        title: "雨情数据查询"
      },
      component: () => import('../view/data/rain_data'),
    },{
      path: '/pressure_data',
      name: 'pressure_data',
      meta: {
        title: "渗压数据查询"
      },
      component: () => import('../view/data/pressure_data'),
    },{
      path: '/gnss_data',
      name: 'gnss_data',
      meta: {
        title: "表面位移数据查询"
      },
      component: () => import('../view/data/gnss_data'),
    },{
      path: '/inportData',
      name: 'inportData',
      meta: {
        title: "人工录入数据"
      },
      component: () => import('../view/data/inportData'),
    },{
      path: '/manualEntry',
      name: 'manualEntry',
      meta: {
        title: "数据导出"
      },
      component: () => import('../view/data/manualEntry'),
    },{
      path: '/levelAnalyse',
      name: 'levelAnalyse',
      meta: {
        title: "水位分析"
      },
      component: () => import('../view/analyse/levelAnalyse'),
    },{
      path: '/displacementAnalyse',
      name: 'displacementAnalyse',
      meta: {
        title: "边坡位移分析"
      },
      component: () => import('../view/analyse/displacementAnalyse'),
    },{
      path: '/waterQualityAnalyse',
      name: 'waterQualityAnalyse',
      meta: {
        title: "水质分析"
      },
      component: () => import('../view/analyse/waterQualityAnalyse'),
    },{
      path: '/noiseAnalyse',
      name: 'noiseAnalyse',
      meta: {
        title: "噪声分析"
      },
      component: () => import('../view/analyse/noiseAnalyse'),
    },{
      path: '/PMAnalyse',
      name: 'PMAnalyse',
      meta: {
        title: "PM2.5分析"
      },
      component: () => import('../view/analyse/PMAnalyse'),
    },{
      path: '/rainAnalyse',
      name: 'rainAnalyse',
      meta: {
        title: "雨量分析"
      },
      component: () => import('../view/analyse/rainAnalyse'),
    },{
      path: '/inspection',
      name: 'inspection',
      meta: {
        title: "水库巡检"
      },
      component: () => import('../view/maintain/inspection'),
    },{
      path: '/maintenance-repair',
      name: 'maintenance-repair',
      meta: {
        title: "养护维修"
      },
      component: () => import('../view/maintain/maintenance-repair'),
    },{
      path: '/order_record',
      name: 'order_record',
      meta: {
        title: "巡检工单记录表"
      },
      component: () => import('../view/maintain/order_record'),
    },{
      path: '/order_record_cleaning',
      name: 'order_record_cleaning',
      meta: {
        title: "保洁工单记录表"
      },
      component: () => import('../view/maintain/order_record_cleaning'),
    },{
      path: '/order_record_maintenan',
      name: 'order_record_maintenan',
      meta: {
        title: "养护维修工单记录表"
      },
      component: () => import('../view/maintain/order_record_maintenan'),
    },{
      path: '/cleaning',
      name: 'cleaning',
      meta: {
        title: "水库保洁"
      },
      component: () => import('../view/maintain/cleaning'),
    },{
      path: '/operation-examination',
      name: 'operation-examination',
      meta: {
        title: "运行考核"
      },
      component: () => import('../view/maintain/operation-examination'),
    },{
      path: '/question-list',
      name: 'question-list',
      meta: {
        title: "问题列表"
      },
      component: () => import('../view/maintain/question-list'),
    },{
      path: '/level-monitoring',
      name: 'level-monitoring',
      meta: {
        title: "水情监测"
      },
      component: () => import('../view/integrated-monitoring/level-monitoring'),
    },{
      path: '/rain-monitoring',
      name: 'rain-monitoring',
      meta: {
        title: "雨情监测"
      },
      component: () => import('../view/integrated-monitoring/rain-monitoring'),
    },{
      path: '/image-monitoring',
      name: 'image-monitoring',
      meta: {
        title: "图像监测"
      },
      component: () => import('../view/integrated-monitoring/image-monitoring'),
    },{
      path: '/video-monitoring',
      name: 'video-monitoring',
      meta: {
        title: "视频监测"
      },
      component: () => import('../view/integrated-monitoring/video-monitoring'),
    },{
      path: '/waterQuality-monitoring',
      name: 'waterQuality-monitoring',
      meta: {
        title: "水质监测"
      },
      component: () => import('../view/integrated-monitoring/waterQuality-monitoring'),
    },{
      path: '/warnning-monitoring',
      name: 'warnning-monitoring',
      meta: {
        title: "预警信息"
      },
      component: () => import('../view/integrated-monitoring/warnning-monitoring'),
    },{
      path: '/flow-monitoring',
      name: 'flow-monitoring',
      meta: {
        title: "流量监测"
      },
      component: () => import('../view/integrated-monitoring/flow-monitoring'),
    },{
      path: '/damSafe-monitoring',
      name: 'damSafe-monitoring',
      meta: {
        title: "大坝安全监测"
      },
      component: () => import('../view/integrated-monitoring/damSafe-monitoring'),
    },{
      path: '/gate-control',
      name: 'gate-control',
      meta: {
        title: "闸门控制"
      },
      component: () => import('../view/integrated-monitoring/gate-control'),
    },{
      path: '/piezometric-pressure',
      name: 'piezometric-pressure',
      meta: {
        title: "渗压分析"
      },
      component: () => import('../view/safety-monitoring/piezometric-pressure'),
    },{
      path: '/seepage-flow',
      name: 'seepage-flow',
      meta: {
        title: "渗流量分析"
      },
      component: () => import('../view/safety-monitoring/seepage-flow'),
    },{
      path: '/air-temperature',
      name: 'air-temperature',
      meta: {
        title: "气温分析"
      },
      component: () => import('../view/safety-monitoring/air-temperature'),
    },{
	  path: '/air-pressure',
	  name: 'air-pressure',
	  meta: {
	    title: "气压分析"
	  },
	  component: () => import('../view/safety-monitoring/air-pressure'),
	},{
	  path: '/reservoir-level',
	  name: 'reservoir-level',
	  meta: {
	    title: "库水位分析"
	  },
	  component: () => import('../view/safety-monitoring/reservoir-level'),
	},{
	  path: '/surface-displacement',
	  name: 'surface-displacement',
	  meta: {
	    title: "表面位移"
	  },
	  component: () => import('../view/safety-monitoring/surface-displacement'),
	},{
	  path: '/capacity-curve',
	  name: 'capacity-curve',
	  meta: {
	    title: "库容曲线"
	  },
	  component: () => import('../view/safety-monitoring/capacity-curve'),
	},{
	  path: '/seepage-line',
	  name: 'seepage-line',
	  meta: {
	    title: "浸润线示意图"
	  },
	  component: () => import('../view/safety-monitoring/seepage-line'),
	},{
	  path: '/flow-analysis',
	  name: 'flow-analysis',
	  meta: {
	    title: "流量分析"
	  },
	  component: () => import('../view/meta-analysis/flow-analysis'),
	},{
	  path: '/water-analysis',
	  name: 'water-analysis',
	  meta: {
	    title: "水情分析"
	  },
	  component: () => import('../view/meta-analysis/water-analysis'),
	},{
	  path: '/rain-analysis',
	  name: 'rain-analysis',
	  meta: {
	    title: "雨情分析"
	  },
	  component: () => import('../view/meta-analysis/rain-analysis'),
	},{
	  path: '/quality-analysis',
	  name: 'quality-analysis',
	  meta: {
	    title: "水质分析"
	  },
	  component: () => import('../view/meta-analysis/quality-analysis'),
	},{
	  path: '/operation-manage',
	  name: 'operation-manage',
	  meta: {
	    title: "运维统计"
	  },
	  component: () => import('../view/meta-analysis/operation-manage'),
	},{
	  path: '/warnning-analysis',
	  name: 'warnning-analysis',
	  meta: {
	    title: "预警分析"
	  },
	  component: () => import('../view/meta-analysis/warnning-analysis'),
	},{
	  path: '/annual-data',
	  name: 'annual-data',
	  meta: {
	    title: "雨情报表"
	  },
	  component: () => import('../view/meta-analysis/annual-data'),
	},{
	  path: '/level-analysis',
	  name: 'level-analysis',
	  meta: {
	    title: "库水位报表"
	  },
	  component: () => import('../view/meta-analysis/level-analysis'),
	},{
	  path: '/reservoir-list',
	  name: 'reservoir-list',
	  meta: {
	    title: "水库列表"
	  },
	  component: () => import('../view/reservoir-manage/reservoir-list'),
	},{
	  path: '/control-target',
	  name: 'control-target',
	  meta: {
	    title: "控制指标"
	  },
	  component: () => import('../view/reservoir-manage/control-target'),
	},{
	  path: '/three-people',
	  name: 'three-people',
	  meta: {
	    title: "三个责任人"
	  },
	  component: () => import('../view/reservoir-manage/three-people'),
	},{
	  path: '/reservoir-capacity',
	  name: 'reservoir-capacity',
	  meta: {
	    title: "水库库容"
	  },
	  component: () => import('../view/reservoir-manage/reservoir-capacity'),
	},{
	  path: '/reservoir-structural',
	  name: 'reservoir-structural',
	  meta: {
	    title: "水库结构体"
	  },
	  component: () => import('../view/reservoir-manage/reservoir-structural'),
	},{
	  path: '/site-manage',
	  name: 'site-manage',
	  meta: {
	    title: "测站管理"
	  },
	  component: () => import('../view/reservoir-manage/site-manage'),
	},{
	  path: '/surface-manage',
	  name: 'surface-manage',
	  meta: {
	    title: "断面管理"
	  },
	  component: () => import('../view/reservoir-manage/surface-manage'),
	},{
	  path: '/structural_manage',
	  name: 'structural_manage',
	  meta: {
	    title: "结构体管理"
	  },
	  component: () => import('../view/reservoir-manage/structural_manage'),
	},{
	  path: '/operation-project-manage',
	  name: 'operation-project-manage',
	  meta: {
	    title: "运维项目管理"
	  },
	  component: () => import('../view/reservoir-manage/operation-project-manage'),
	},{
	  path: '/inspection_items_manage',
	  name: 'inspection_items_manage',
	  meta: {
	    title: "巡检项管理"
	  },
	  component: () => import('../view/reservoir-manage/inspection_items_manage'),
	},{
	  path: '/maintain_items_manage',
	  name: 'maintain_items_manage',
	  meta: {
	    title: "养护项管理"
	  },
	  component: () => import('../view/reservoir-manage/maintain_items_manage'),
	},{
	  path: '/cleaning_items_manage',
	  name: 'cleaning_items_manage',
	  meta: {
	    title: "保洁项管理"
	  },
	  component: () => import('../view/reservoir-manage/cleaning_items_manage'),
	},{
	  path: '/warnning-setting',
	  name: 'warnning-setting',
	  meta: {
	    title: "预警配置"
	  },
	  component: () => import('../view/reservoir-manage/warnning-setting'),
	},{
	  path: '/reservoir-supporting-facilities',
	  name: 'reservoir-supporting-facilities',
	  meta: {
	    title: "水库配套设施"
	  },
	  component: () => import('../view/reservoir-manage/reservoir-supporting-facilities'),
	},{
	  path: '/revervoir-visit-log',
	  name: 'revervoir-visit-log',
	  meta: {
	    title: "水库到访日志"
	  },
	  component: () => import('../view/reservoir-manage/revervoir-visit-log'),
	},{
	  path: '/material-management',
	  name: 'material-management',
	  meta: {
	    title: "应急物资管理"
	  },
	  component: () => import('../view/reservoir-manage/material-management'),
	},{
	  path: '/address-book',
	  name: 'address-book',
	  meta: {
	    title: "应急通讯录"
	  },
	  component: () => import('../view/reservoir-manage/address-book'),
	},{
	  path: '/organizational-management',
	  name: 'organizational-management',
	  meta: {
	    title: "机构管理"
	  },
	  component: () => import('../view/system-manage/organizational-management'),
	},
	,{
	  path: '/user-management',
	  name: 'user-management',
	  meta: {
	    title: "用户管理"
	  },
	  component: () => import('../view/system-manage/user-management'),
	},{
	  path: '/role-management',
	  name: 'role-management',
	  meta: {
	    title: "角色管理"
	  },
	  component: () => import('../view/system-manage/role-management'),
	},{
	  path: '/menu-list',
	  name: 'menu-list',
	  meta: {
	    title: "菜单列表"
	  },
	  component: () => import('../view/system-manage/menu-list'),
	},{
	  path: '/authority-management',
	  name: 'authority-management',
	  meta: {
	    title: "权限管理"
	  },
	  component: () => import('../view/system-manage/authority-management'),
	},{
	  path: '/data-dictionary',
	  name: 'data-dictionary',
	  meta: {
	    title: "数据字典管理"
	  },
	  component: () => import('../view/system-manage/data-dictionary'),
	},{
	  path: '/notice-management',
	  name: 'notice-management',
	  meta: {
	    title: "通知管理"
	  },
	  component: () => import('../view/system-manage/notice-management'),
	},{
	  path: '/assignment-manage',
	  name: 'assignment-manage',
	  meta: {
	    title: "任务管理"
	  },
	  component: () => import('../view/system-manage/assignment-manage'),
	},{
	  path: '/warnning-data',
	  name: 'warnning-data',
	  meta: {
	    title: "预警信息"
	  },
	  component: () => import('../view/system-manage/warnning-data'),
	}
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {//如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
  next()
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js